import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectContract,
  selectContractLoading,
} from "../../../redux/contract/selectors";
import dayjs from "dayjs";
import { NoneSelectedMessage } from "../../common/NoneSelected";
import { useTranslation } from "react-i18next";
import CustomerDialog from "./CustomerDialog";
import { openModal } from '../../../redux/modal/modalSlice';
import { IconButton } from "@material-ui/core";
import iconoAdd from '../../../images/iconoAdd.svg';
import iconEditarLead from '../../../images/iconEditarLead.svg';
import { createCustomer, editCustomer } from '../../../redux/customers/thunks'
import { QUERY_GET_CONTRACT } from "../../../fetch/constantQueries";
import { errorHandler } from "../../../commonFunctions/errorHandler";

function ReadOnlyInput(props) {
  return (
    <>
      <span className={"input-wrapper-label"}> {props.label} </span>
      <span title={props.field?.length > 80 ? props.tooltip : null}>
        {props.date
          ? props.field
            ? dayjs(props.field, "DD/MM/YYYY").format("DD/MM/YYYY")
            : null
          : props.field}
      </span>
    </>
  );
}

function IdentifyLead(props) {
  const { t } = useTranslation();
  const { mode } = props;
  const contract = useSelector(selectContract);
  const loadingContract = useSelector(selectContractLoading);
  const dispatch = useDispatch();

  const customerInfo = [
    // {label: "Nombre conductor:", field: contract.driverName},
    // {label: "Apellido conductor:", field: contract.driverSurname},
    // {label: "C.Cli:", field: contract.customerCode},
    // {label: "Cliente:", field: contract.customerName, span:2},
    // {label: "Tlf. cliente:", field: contract.customerPhone},

    { label: 'CPF:', field: contract.customerCPF },
    //{ label: `${t("Code")}:`, field: contract.customerCode, span: 2 },
    { label: `${t("Customer")}:`, field: contract.customerName, span: 2 },
    { label: `${t("Phone")}:`, field: contract.customerPhone },
    { label: 'E-mail:', field: contract.customerEmail },
    { label: `${t("Address.Name")}:`, field: contract.customerAddress },
    { label: `${t("Address.ZipCode")}:`, field: contract.customerZipCode },
    { label: `${t("Address.City")}:`, field: contract.customerCity },
    { label: `${t("Address.Neighborhood")}:`, field: contract.customerNeighborhood },
    { label: `${t("Address.State")}:`, field: contract.customerState },
  ];

  const contractInfo = [
    // { label: `Nº ${t("Contract")}:`, field: contract.contractNumber },
    // { label: `${t("StartDate")} ${t("Contract")}:`, field: contract.contractStartDate, date: true },
    // { label: `${t("EndDate")} ${t("Contract")}:`, field: contract.contractEndDate, date: true},

    {label: "DealerCode:", field: contract.dealerCode},
    {label: "Dealer:", field: contract.dealer},
    {label: "Data de venda:", field: contract.salesDate},
    {label: "Data da entrega:", field: contract.deliveryDate}

    //{label: "Fecha terminación:", field: contract.terminationdate, date:true},
    //{label: "Data Fim estimada:", field: contract.estimatedEndDate, date:true},
    // {label: "Neumáticos Contratados:", field: contract.tyresContracted},
    // {label: "Tamaño neumático:", field: contract.tyreSize},
    // {label: "Neumáticos ilimitados:", field: contract.unlimitedTyres},
    // {label: "Tarjeta combustible:", field: contract.gasCard?"Si":"No"},
    // {label: "Vehiculo sustitución:", field: contract.replacementVehicle?"Si":"No"},
    // {label: "Tipo seguro:", field: contract.insuranceType},
    // {label: "Servicio R&E:", field: contract.vipService?"Si":"No"},
  ];

  const vehicleInfo = [
    { label: "Marca:", field: contract.brand },
    { label: "Modelo:", field: contract.model, span: 2 },
    { label: "Ano/Modelo:", field: contract.year },
    { label: "Placa:", field: contract.plate },
    { label: "Chassi:", field: contract.chassisNumber },
    { label: "Cor:", field: contract.color }
  ];

  return (
    <>
      {contract.customerId ? (
        <>
          {/* <IconButton onClick={openCustomerDialog} style={{padding: 2}}>
            <img src={contract?.customerId != null ? iconEditarLead : iconoAdd} alt="Editar cliente" title={'Editar cliente'} width={20} />
          </IconButton> */}
          <div id="grid-contract-container">
            {mode === "customer" &&
              <>
              {customerInfo.map((e) => (
                <ReadOnlyInput
                  key={e.label}
                  label={e.label}
                  field={e.field}
                  date={e.date}
                  tooltip={e.field}
                />
              ))}
              </>
              }
            {mode === "contract" &&
              contractInfo.map((e) => (
                <ReadOnlyInput
                  key={e.label}
                  label={e.label}
                  field={e.field}
                  date={e.date}
                  tooltip={e.field}
                />
              ))}
            {mode === "vehicle" &&
              vehicleInfo.map((e) => (
                <ReadOnlyInput
                  key={e.label}
                  label={e.label}
                  field={e.field}
                  date={e.date}
                  tooltip={e.field}
                />
              ))}
          </div>
        </>
      ) : (
        <>
          <NoneSelectedMessage
            message={
              loadingContract !== "succeeded"
                ? t("NoSelectedCustomer")
                : t("NoAssignedCustomer")
            }
          />
         {/* <span>
            <IconButton onClick={openCustomerDialog} style={{padding: 2}}>
                <img src={contract?.customerId != null ? iconEditarLead : iconoAdd} alt="Editar cliente" title={'Editar cliente'} width={20} />
              </IconButton>
          </span> */}
        </>
      )}
    </>
  );
}

export { IdentifyLead };
